type GtmEventLabel = "submit" | "gtag";

type GtmActionInstagramViewer =
  | "viewer_click_tracking"
  | "viewer_click_analytics"
  | "viewer_click_purchase"
  | "viewer_click_sign_up"
  | "viewer_click_download_all"
  | "viewer_page_switch"
  | "viewer_full_screen"
  | "viewer_full_screen_content"
  | "viewer_limit_content_purchase"
  | "viewer_limit_content_signup"
  | "viewer_limit_purchase"
  | "viewer_limit_proxies"
  | "viewer_limit_sign_up"
  | "viewer_results_error"
  | "viewer_results_private"
  | "viewer_results_success"
  | "viewer_results_nocontent"
  | "viewer_guest_results_success"
  | "viewer_search_profile"
  | "viewer_search_stories"
  | "viewer_search_highlights"
  | "viewer_search_posts"
  | "viewer_search_reels";

type GtmActionInstagramDownloader =
  | "downloader_click_sign_up"
  | "downloader_click_purchase"
  | "downloader_click_download_full_profile"
  | "downloader_click_download_all"
  | "downloader_click_tracking"
  | "downloader_click_analytics"
  | "downloader_full_screen_content"
  | "downloader_full_screen"
  | "downloader_search_profile"
  | "downloader_search_photo"
  | "downloader_search_video"
  | "downloader_search_stories"
  | "downloader_search_reels"
  | "downloader_search_dp"
  | "downloader_search_highlights"
  | "downloader_page_switch"
  | "downloader_limit_purchase"
  | "downloader_limit_sign_up"
  | "downloader_limit_proxies"
  | "downloader_limit_content_purchase"
  | "downloader_limit_content_signup"
  | "downloader_results_error"
  | "downloader_results_private"
  | "downloader_results_success"
  | "downloader_results_nocontent"
  | "downloader_guest_results_success";

type GtmActionProfileAnalyzer =
  | "analyzer_click_show_stories"
  | "analyzer_click_similar"
  | "analyzer_click_more"
  | "analyzer_guest_search_profile"
  | "analyzer_guest_results_private"
  | "analyzer_guest_results_error"
  | "analyzer_guest_results_success"
  | "analyzer_guest_results_success_ref"
  | "analyzer_user_search_profile"
  | "analyzer_user_results_private"
  | "analyzer_user_results_error"
  | "analyzer_user_results_success"
  | "analyzer_user_results_success_ref"
  | "analyzer_member_search_profile"
  | "analyzer_member_results_private"
  | "analyzer_member_results_error"
  | "analyzer_member_results_success"
  | "analyzer_member_results_success_ref";

type GtmActionInstagramSearch =
  | "search_find"
  | "search_results_nocontent"
  | "search_sign_up"
  | "search_click_viewer"
  | "search_click_analytics"
  | "search_click_username"
  | "search_click_add_to_list"
  | "search_click_download_checked"
  | "search_click_sign_up"
  | "search_click_purchase";

type GtmActionMapping = {
  viewer: GtmActionInstagramViewer;
  downloader: GtmActionInstagramDownloader;
  analyzer: GtmActionProfileAnalyzer;
  search: GtmActionInstagramSearch;
};

export const gtmEvent = <C extends keyof GtmActionMapping>(
  category: C,
  action: GtmActionMapping[C],
  label: GtmEventLabel,
) => {
  try {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
    });
  } catch (error) {
    // gtag not loaded
  }
};

export const dispatchGtagEvent = (send_to: string) => {
  try {
    window.gtag("event", "conversion", {
      send_to,
    });
  } catch (error) {
    // gtag not loaded
  }
};

export const viewer_limit_sign_up = () => {
  dispatchGtagEvent("AW-11007046127/cir7CJm7sLgaEO_jyIAp");
};

export const viewer_limit_purchase = () => {
  dispatchGtagEvent("AW-11007046127/xITECJy7sLgaEO_jyIAp");
};

export const viewer_guest_results_success = () => {
  dispatchGtagEvent("AW-11007046127/LdDOCJ-7sLgaEO_jyIAp");
};

export const viewer_results_success = () => {
  dispatchGtagEvent("AW-11007046127/4dc6CKK7sLgaEO_jyIAp");
};
